import { render, staticRenderFns } from "./custom-branding.vue?vue&type=template&id=5fb7fdf4&scoped=true&"
import script from "./custom-branding.vue?vue&type=script&lang=js&"
export * from "./custom-branding.vue?vue&type=script&lang=js&"
import style0 from "./custom-branding.vue?vue&type=style&index=0&id=5fb7fdf4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb7fdf4",
  null
  
)

export default component.exports